import { Mail, MapPin, MessageCircle } from "lucide-react";import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { ContactForm } from "../ContactForm";
import { CONTACT } from "../../data/site";
import { useContents } from "../../hooks/useContents";

export const ContactInfo = () => {
  const c = useContents();
  const email = c("contact_email", CONTACT.email);
  const wa = `https://wa.me/${c("contact_whatsapp", "393208978227")}`;
  return (
  <div data-testid="contact-info-block" className="bg-card border border-steel p-6 sm:p-8">
    <p className="overline-label">Contatti diretti</p>
    <h3 className="font-display font-bold text-xl uppercase tracking-tight text-white mt-3">{CONTACT.name}</h3>
    <ul className="mt-6 space-y-5">
      <li>
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-cement/70 mb-1">Email</p>
        <a href={`mailto:${email}`} data-testid="contact-info-email" className="text-metal hover:text-forest-glow transition-colors break-all">
          {email}
        </a>
      </li>
      <li>
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-cement/70 mb-1">Area operativa</p>
        <p className="text-metal flex items-center gap-2"><MapPin size={15} className="text-forest-glow" /> {CONTACT.area}</p>
      </li>
    </ul>
    <div className="mt-8 grid grid-cols-2 gap-2">
      <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-button" className="btn-primary !px-2 !py-3 !text-[11px]">
        <MessageCircle size={15} /> WhatsApp
      </a>
      <a href={`mailto:${email}`} data-testid="contact-email-button" className="btn-ghost !px-2 !py-3 !text-[11px]">
        <Mail size={15} /> Email
      </a>
    </div>
  </div>
  );
};

export const ContattiSection = ({ number = "07", compact = false }) => (
  <section id="preventivo" data-testid="contatti-section" className={`${compact ? "py-16 lg:py-24" : "py-20 lg:py-32"} bg-graphite border-t border-steel`}>
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <SectionHeading
        number={number}
        overline="Preventivo gratuito"
        lines={["Raccontaci il tuo progetto"]}
        description="Compila il modulo: ti ricontatteremo per valutare insieme il lavoro e preparare un preventivo chiaro."
      />
      <div className="mt-12 lg:mt-16 grid lg:grid-cols-[380px_1fr] gap-6 items-start">
        <Reveal>
          <ContactInfo />
        </Reveal>
        <Reveal delay={0.12}>
          <ContactForm />
        </Reveal>
      </div>
    </div>
  </section>
);
